/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_PENDING = (state) => {
    state.pending = true
}

/**
 * Reset the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_PENDING = (state) => {
    state.pending = false
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Hydrate the invitations state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const GET_INVITES_SUCCESS = (state, payload) => {
    state.myInvites.data = payload.data
    state.myInvites.meta = payload.meta
}

/**
 * Hydrate the sent invitations list
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const GET_SENT_INVITES_SUCCESS = (state, payload) => {
    state.sentInvites.data = payload.data
    state.sentInvites.meta = payload.meta
}

/**
 * Handle invitation acceptance
 *
 * @param  {Object} state
 * @return {[type]}
 */
const ACCEPT_INVITE = (state, id) => {
    let inviteIndex = state.myInvites.data.findIndex(invite => invite.invitation_id === id)

    if (inviteIndex > -1) {
        state.myInvites.data.splice(inviteIndex, 1)
    }
}

/**
 * Remove single invite from state
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Void}
 */
const REJECT_INVITE = (state, id) => {
    let inviteIndex = state.myInvites.data.findIndex(invite => invite.invitation_id === id)

    if (inviteIndex > -1) {
        state.myInvites.data.splice(inviteIndex, 1)
    }
}

/**
 * Update invite data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const UPDATE_PRIVILEGE_LEVEL = (state, payload) => {
    let invite = state.sentInvites.data.find(
        item => item.invitation_id === payload.id
    )

    if (invite) {
        invite.privilege_level = payload.level
    }
}

/**
 * Remove a sent invite
 *
 * @param  {Object} state
 * @return {Void}
 */
const REMOVE_INVITE = (state, id) => {
    state.sentInvites.data = state.sentInvites.data.filter(
        item => item.invitation_id !== id
    )
}

/**
 * Show the agreement modal
 *
 * @param  {Object} state
 * @return {Void}
 */
const SHOW_AGREEMENT_MODAL = (state, payload) => {
    state.agreementModal.id = payload.id
    state.agreementModal.data = payload.conf_agreement
    state.agreementModal.show = true
}

/**
 * Show the agreement modal
 *
 * @param  {Object} state
 * @return {Void}
 */
const CLOSE_AGREEMENT_MODAL = (state) => {
    state.agreementModal.success = false
    state.agreementModal.id = null
    state.agreementModal.accepted = false
    state.agreementModal.show = false
    state.agreementModal.data = null
}

/**
 * Change the accepted state
 *
 * @param  {Object} state
 * @param  {Boolean} checked
 * @return {Void}
 */
const UPDATE_AGREEMENT_VALUE = (state, checked) => {
    state.agreementModal.accepted = checked
}

/**
 * Change the success state
 *
 * @param  {Object} state
 * @return {Void}
 */
const ACCEPT_AGREEMENT_AND_INVITE = (state) => {
    state.agreementModal.success = true
}

export default {
    SET_PENDING,
    RESET_PENDING,
    RESET_STATE,
    ACCEPT_INVITE,
    REJECT_INVITE,
    REMOVE_INVITE,
    GET_INVITES_SUCCESS,
    UPDATE_PRIVILEGE_LEVEL,
    GET_SENT_INVITES_SUCCESS,
    SHOW_AGREEMENT_MODAL,
    CLOSE_AGREEMENT_MODAL,
    UPDATE_AGREEMENT_VALUE,
    ACCEPT_AGREEMENT_AND_INVITE
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/invitations/mutations.js